import { useCallback, useMemo } from 'react';
import { HighwayArea } from '@thive/fddm-types';

import { SelectInput } from '@common/components/inputs';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const OPTIONS: { label: string; value: HighwayArea['connectUturns'] }[] = [
  { label: 'No', value: 'NO_UTURN_MAPPING' },
  { label: 'Curved', value: 'MAP_UTURNS_WITHOUT_PIVOTS' },
  { label: 'Pivot', value: 'MAP_UTURNS_WITH_PIVOTS' },
];

type Props = {
  selectedHighwayArea: HighwayArea;
};

export function HighwayConnectUturns({ selectedHighwayArea }: Props) {
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const onChange = useCallback(
    (newValue: HighwayArea['connectUturns']) => {
      fddmSvc.updateArea({ ...selectedHighwayArea, connectUturns: newValue });
      fddmSvc.setPreference('highwayArea.connectUturns', newValue);
    },
    [selectedHighwayArea, fddmSvc],
  );

  const isOneWay = selectedHighwayArea.highwayPoiSpecs[0].roadType === 'ONE_WAY';

  return (
    <SelectInput
      options={OPTIONS}
      onChange={onChange}
      value={selectedHighwayArea.connectUturns}
      disabled={isOneWay}
    />
  );
}
